import { axiosInstance } from '../instance'

export const qrmInstance = new axiosInstance(
  process.env.REACT_APP_API_ENDPOINT as string
)
